import { render, staticRenderFns } from "./CommonSign.vue?vue&type=template&id=bff7ea98&scoped=true"
import script from "./CommonSign.vue?vue&type=script&lang=js"
export * from "./CommonSign.vue?vue&type=script&lang=js"
import style0 from "./CommonSign.vue?vue&type=style&index=0&id=bff7ea98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff7ea98",
  null
  
)

export default component.exports